/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconUserUp = createReactComponent("outline", "user-up", "IconUserUp", [["path", { "d": "M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0", "key": "svg-0" }], ["path", { "d": "M6 21v-2a4 4 0 0 1 4 -4h4", "key": "svg-1" }], ["path", { "d": "M19 22v-6", "key": "svg-2" }], ["path", { "d": "M22 19l-3 -3l-3 3", "key": "svg-3" }]]);

export { IconUserUp as default };
//# sourceMappingURL=IconUserUp.mjs.map
